<div class="{{ 'direction' |translate }}">
<app-header></app-header>

<div class="container-fluid">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
</div>